"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObtainNewPasscode = ObtainNewPasscode;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ObtainNewPasscode(_ref) {
  var id = _ref.id,
    show = _ref.show,
    onHide = _ref.onHide,
    handleNewPasscode = _ref.handleNewPasscode,
    variant = _ref.variant,
    modalTitle = _ref.modalTitle,
    modalBody = _ref.modalBody,
    cancelBtnText = _ref.cancelBtnText,
    cancelBtnTextClass = _ref.cancelBtnTextClass,
    submitBtnText = _ref.submitBtnText,
    register = _ref.register;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    submitBtnDisabled = _useState2[0],
    setsubmitBtnDisabled = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    missMatchedPasscode = _useState4[0],
    setmissMatchedPasscode = _useState4[1];
  (0, _react.useEffect)(function () {
    if (id === "setupPasscodeOtp") {
      setsubmitBtnDisabled("disabled");
    }
  }, [id]);
  var btnValidation = function btnValidation() {
    if (id === "setupPasscodeOtp") {
      var _document, _document$getElementB, _document2, _document2$getElement, _document3, _document3$getElement, _document4, _document4$getElement, _document5, _document5$getElement, _document6, _document6$getElement, _document7, _document7$getElement, _document8, _document8$getElement, _document9, _document9$getElement, _document10, _document10$getElemen;
      var inputfirst = (_document = document) === null || _document === void 0 ? void 0 : (_document$getElementB = _document.getElementById("inputfirst")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
      var inputsecond = (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$getElement = _document2.getElementById("inputsecond")) === null || _document2$getElement === void 0 ? void 0 : _document2$getElement.value;
      var inputthird = (_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$getElement = _document3.getElementById("inputthird")) === null || _document3$getElement === void 0 ? void 0 : _document3$getElement.value;
      var inputfourth = (_document4 = document) === null || _document4 === void 0 ? void 0 : (_document4$getElement = _document4.getElementById("inputfourth")) === null || _document4$getElement === void 0 ? void 0 : _document4$getElement.value;
      var inputfive = (_document5 = document) === null || _document5 === void 0 ? void 0 : (_document5$getElement = _document5.getElementById("inputfive")) === null || _document5$getElement === void 0 ? void 0 : _document5$getElement.value;
      var inputfirst_ = (_document6 = document) === null || _document6 === void 0 ? void 0 : (_document6$getElement = _document6.getElementById("inputfirst_")) === null || _document6$getElement === void 0 ? void 0 : _document6$getElement.value;
      var inputsecond_ = (_document7 = document) === null || _document7 === void 0 ? void 0 : (_document7$getElement = _document7.getElementById("inputsecond_")) === null || _document7$getElement === void 0 ? void 0 : _document7$getElement.value;
      var inputthird_ = (_document8 = document) === null || _document8 === void 0 ? void 0 : (_document8$getElement = _document8.getElementById("inputthird_")) === null || _document8$getElement === void 0 ? void 0 : _document8$getElement.value;
      var inputfourth_ = (_document9 = document) === null || _document9 === void 0 ? void 0 : (_document9$getElement = _document9.getElementById("inputfourth_")) === null || _document9$getElement === void 0 ? void 0 : _document9$getElement.value;
      var inputfive_ = (_document10 = document) === null || _document10 === void 0 ? void 0 : (_document10$getElemen = _document10.getElementById("inputfive_")) === null || _document10$getElemen === void 0 ? void 0 : _document10$getElemen.value;
      if (inputfirst === "" || inputsecond === "" || inputthird === "" || inputfourth === "" || inputfive === "") {
        setsubmitBtnDisabled("disabled");
      } else {
        if (inputfirst !== inputfirst_) {
          setsubmitBtnDisabled("disabled");
        } else if (inputsecond !== inputsecond_) {
          setsubmitBtnDisabled("disabled");
        } else if (inputthird !== inputthird_) {
          setsubmitBtnDisabled("disabled");
        } else if (inputfourth !== inputfourth_) {
          setsubmitBtnDisabled("disabled");
        } else if (inputfive !== inputfive_) {
          setsubmitBtnDisabled("disabled");
        } else {
          setsubmitBtnDisabled("");
        }
      }
      if ((inputfirst === null || inputfirst === void 0 ? void 0 : inputfirst.length) > 0 && (inputsecond === null || inputsecond === void 0 ? void 0 : inputsecond.length) > 0 && (inputthird === null || inputthird === void 0 ? void 0 : inputthird.length) > 0 && (inputfourth === null || inputfourth === void 0 ? void 0 : inputfourth.length) > 0 && (inputfive === null || inputfive === void 0 ? void 0 : inputfive.length) > 0 && (inputfirst_ === null || inputfirst_ === void 0 ? void 0 : inputfirst_.length) > 0 && (inputsecond_ === null || inputsecond_ === void 0 ? void 0 : inputsecond_.length) > 0 && (inputthird_ === null || inputthird_ === void 0 ? void 0 : inputthird_.length) > 0 && (inputfourth_ === null || inputfourth_ === void 0 ? void 0 : inputfourth_.length) > 0 && (inputfive_ === null || inputfive_ === void 0 ? void 0 : inputfive_.length) > 0 && inputfirst + inputsecond + inputthird + inputfourth + inputfive !== inputfirst_ + inputsecond_ + inputthird_ + inputfourth_ + inputfive_) {
        setmissMatchedPasscode(true);
      } else {
        setmissMatchedPasscode(false);
      }
    } else {
      setsubmitBtnDisabled("");
    }
  };
  var shiftCursor = function shiftCursor(e, targetElement) {
    var _e$target, _e$target$value;
    var element = document.getElementById(targetElement);
    if ((e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$value = _e$target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) > 0 && element) {
      element.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    id: id,
    show: show,
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-" + variant + " text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, modalTitle)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, id !== "setupPasscodeOtp" ? /*#__PURE__*/_react.default.createElement("p", null, modalBody) : /*#__PURE__*/_react.default.createElement("div", {
    className: "passcode-inputs"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "small"
  }, "Use any combination of letters and numbers. Passcodes are case sensitive."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "Enter 5-Digit Passcode."), /*#__PURE__*/_react.default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfirst",
    type: "text",
    maxlength: "1",
    "aria-label": "first digit",
    className: "btn"
  }, register && register("inputfirst"), {
    onChange: function onChange(e) {
      shiftCursor(e, "inputsecond");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputsecond",
    type: "text",
    maxlength: "1",
    "aria-label": "second digit",
    className: "btn"
  }, register && register("inputsecond"), {
    onChange: function onChange(e) {
      shiftCursor(e, "inputthird");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputthird",
    type: "text",
    maxlength: "1",
    "aria-label": "third digit",
    className: "btn"
  }, register && register("inputthird"), {
    onChange: function onChange(e) {
      shiftCursor(e, "inputfourth");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfourth",
    type: "text",
    maxlength: "1",
    "aria-label": "fourth digit",
    className: "btn"
  }, register && register("inputfourth"), {
    onChange: function onChange(e) {
      shiftCursor(e, "inputfive");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfive",
    type: "text",
    maxlength: "1",
    "aria-label": "five digit",
    className: "btn"
  }, register && register("inputfive"), {
    onChange: function onChange(e) {
      shiftCursor(e, "inputfirst_");
      btnValidation();
    }
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-2"
  }, "Confirm."), /*#__PURE__*/_react.default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfirst_",
    type: "text",
    maxlength: "1",
    "aria-label": "first digit",
    className: "btn "
  }, register && register("inputfirst_"), {
    onChange: function onChange(e) {
      // let inputCurrent = e?.target;
      // let inputTarget =
      //   document?.getElementById("inputfirst")?.value;
      // if (inputCurrent.value !== inputTarget) {
      //   inputCurrent.classList.add("errorBgColor");
      // } else {
      //   inputCurrent.classList.remove("errorBgColor");
      // }
      shiftCursor(e, "inputsecond_");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputsecond_",
    type: "text",
    maxlength: "1",
    "aria-label": "second digit",
    className: "btn "
  }, register && register("inputsecond_"), {
    onChange: function onChange(e) {
      // let inputCurrent = e?.target;
      // let inputTarget =
      //   document?.getElementById("inputsecond")?.value;
      // if (inputCurrent.value !== inputTarget) {
      //   inputCurrent.classList.add("errorBgColor");
      // } else {
      //   inputCurrent.classList.remove("errorBgColor");
      // }
      shiftCursor(e, "inputthird_");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputthird_",
    type: "text",
    maxlength: "1",
    "aria-label": "third digit",
    className: "btn "
  }, register && register("inputthird_"), {
    onChange: function onChange(e) {
      // let inputCurrent = e?.target;
      // let inputTarget =
      //   document?.getElementById("inputthird")?.value;
      // if (inputCurrent.value !== inputTarget) {
      //   inputCurrent.classList.add("errorBgColor");
      // } else {
      //   inputCurrent.classList.remove("errorBgColor");
      // }
      shiftCursor(e, "inputfourth_");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfourth_",
    type: "text",
    maxlength: "1",
    "aria-label": "fourth digit",
    className: "btn "
  }, register && register("inputfourth_"), {
    onChange: function onChange(e) {
      // let inputCurrent = e?.target;
      // let inputTarget =
      //   document?.getElementById("inputfourth")?.value;
      // if (inputCurrent.value !== inputTarget) {
      //   inputCurrent.classList.add("errorBgColor");
      // } else {
      //   inputCurrent.classList.remove("errorBgColor");
      // }
      shiftCursor(e, "inputfive_");
      btnValidation();
    }
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: "inputfive_",
    type: "text",
    maxlength: "1",
    "aria-label": "five digit",
    className: "btn "
  }, register && register("inputfive_"), {
    onChange: function onChange(e) {
      // let inputCurrent = e?.target;
      // let inputTarget =
      //   document?.getElementById("inputfive")?.value;
      // if (inputCurrent.value !== inputTarget) {
      //   inputCurrent.classList.add("errorBgColor");
      // } else {
      //   inputCurrent.classList.remove("errorBgColor");
      // }
      btnValidation();
    }
  }))), missMatchedPasscode && /*#__PURE__*/_react.default.createElement("p", {
    class: "text-danger"
  }, "Confirm passcode does not match."))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: cancelBtnTextClass ? cancelBtnTextClass : "light",
    type: "button",
    className: "shadow-none",
    onClick: onHide
  }, cancelBtnText), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    id: "submitBtn",
    variant: variant,
    type: "button",
    className: "shadow-none text-white " + submitBtnDisabled,
    onClick: handleNewPasscode
  }, submitBtnText)));
}
var _default = ObtainNewPasscode;
exports.default = _default;